import React, { useState, useEffect} from 'react';
import Box from '@mui/material/Box';
import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
import FormControl from '@mui/material/FormControl';
import Select, { SelectChangeEvent } from '@mui/material/Select';
import Button from '@mui/material/Button';
import {Helmet} from "react-helmet";
import {Loading} from "../LoadingComponent";
import Alert from '@mui/material/Alert';
import TextField from '@mui/material/TextField';

import {
  Breadcrumb,
  BreadcrumbItem,
  Col,
  ListGroup,
  ListGroupItem,
  ListGroupItemHeading,
  ListGroupItemText, Row, Table
} from "reactstrap";
import {Link} from "react-router-dom";
import routeTo from "../helpers/RouteTo";


export default function CreateCourseComponent(props) {
  const [productTypesList, setProductTypesList] = useState([])
  const [productLevelList, setProductLevelList] = useState([])
  const [productSubjectList, setProductSubjectList] = useState([])
  const [product, setProduct] = React.useState('');
  const [level, setLevel] = useState('');
  const [subject, setSubject] = useState('');
  const [subjectId, setSubjectId] = useState('');
  const [prodName, setProdName] = useState('')

  const [message, setMessage] = React.useState('')

  useEffect(() => {
    props.getProductType("Dummy")
  }, []);

  useEffect(() => {
    if (props.getProductTypeSuccess && props.getProductTypeSuccess) {
      let prodTypes = Object.keys(props.getProductTypeSuccess.data)
      setProductTypesList(prodTypes)
    }
    if (props.createProductSuccess && props.createProductSuccess) {
      let pId = props.createProductSuccess.data.product_id
      props.history.push(`/vendor/add-content/${pId}`)
    }
    if (props.createProductError && props.createProductError) {
      if (props.createProductError.endsWith('401')) {
        setMessage("Ooops, it look like you're not logged. Sign in and try again")
      }
    }
  }, [props])

  const handleCreateCourse = () => {
    if (product === '' || level === '' || subject === '' || prodName === ''){
      setMessage("Please enter a course name")
    } else {
      let newPayload = {subId: subjectId, name: prodName }
      props.createProduct(newPayload)
    }
  }

  const handleChange = (event) => {
    setProduct(event.target.value);
    setSubject('')
    setLevel('')
    setProdName('')
    let prodLevels = Object.keys(props.getProductTypeSuccess.data[event.target.value])
    setProductLevelList(prodLevels)
  };

  const handleLevelChange = (event) => {
    setLevel(event.target.value);
    let prodSubjects = props.getProductTypeSuccess.data[product][event.target.value]
    setProductSubjectList(prodSubjects)
  }

  const handleSubjectChange = (event, child) => {
    setSubject(event.target.value);
    setSubjectId(child.props.id)
    setMessage('')
  }

  const handleProdNameChange = (event) => {
    setMessage('')
    setProdName(event.target.value);
  };


  return (
    <div>
      <Helmet>
        <title>Create Course</title>
        <meta name="description" content="SEE Tutors" />
      </Helmet>
      <div className="container cpanel">
        <Breadcrumb>
          <BreadcrumbItem><Link to="/">Home</Link></BreadcrumbItem>
          <BreadcrumbItem><Link to="/vendor-dashboard" >Dashboard</Link></BreadcrumbItem>
          <BreadcrumbItem active>Create course</BreadcrumbItem>
        </Breadcrumb>
        <div className="row" style={{paddingTop: '20px', paddingBottom: '20px'}}>
          <div className="page-header col-12">
            <h4 className="page-header-content">Create Course</h4>
            <hr className="fancy-line"/>
          </div>
        </div>
        <div id="contactContainer">
          <div className="row">
            {props.getProductTypeLoader ? (
              <div className="offset-5 offset-lg-6" style={{paddingTop: "100px", paddingBottom: "1220px"}}>
                <Loading />
              </div>
            ) : (
              <div className="container" style={{padding: "24px", textAlign: "center"}}>
                {message ? (
                  <Alert severity="error">{message}</Alert>
                ) : (
                  null
                )
                }
                <Box sx={{ width: 600, margin: "0 auto"}}>
                  <h6 className="headings-create-product">Select Stage</h6>
                  <FormControl fullWidth style={{paddingBottom: "16px"}}>
                    <InputLabel id="demo-simple-select-label">Course</InputLabel>
                    <Select
                      labelId="demo-simple-select-label"
                      id="demo-simple-select"
                      value={product}
                      label="Course Type"
                      className="mui-select"
                      onChange={handleChange}
                    >
                      { productTypesList.map((productType) => (
                        <MenuItem value={productType}>{productType}</MenuItem>
                      ))}
                    </Select>
                  </FormControl>
                  { product ? (
                    <div>
                      <h6 className="headings-create-product">Select Level</h6>
                      <FormControl fullWidth style={{paddingBottom: "16px"}}>
                        <InputLabel id="demo-simple-level-label">Level</InputLabel>
                        <Select
                          labelId="demo-simple-select-level"
                          id="demo-simple-select"
                          value={level}
                          label="Course Type"
                          onChange={handleLevelChange}
                        >
                          { productLevelList.map((productLevel) => (
                            <MenuItem value={productLevel}>{productLevel}</MenuItem>
                          ))}
                        </Select>
                      </FormControl>
                    </div>
                  ): (null)
                  }
                  { level ? (
                    <div>
                      <h6 className="headings-create-product">Select Subject</h6>
                      <FormControl fullWidth style={{paddingBottom: "16px"}}>
                        <InputLabel id="demo-simple-level-label">Subject</InputLabel>
                        <Select
                          labelId="demo-simple-select-level"
                          id="demo-simple-select"
                          value={subject}
                          label="Subject"
                          onChange={handleSubjectChange}
                        >
                          { productSubjectList.map((productSubject) => (
                            <MenuItem id={productSubject.subj_id}
                                      value={productSubject.subj_name}>
                              {productSubject.subj_name}
                            </MenuItem>
                          ))}
                        </Select>
                      </FormControl>

                    </div>
                  ): (null)
                  }
                  { subject ? (
                    <div>
                      <h6 className="headings-create-product">Enter a name for the course</h6>
                      <TextField
                        id="outlined-basic"
                        label="Name"
                        fullWidth
                        value={prodName}
                        onChange={handleProdNameChange}
                        variant="outlined" />
                      <div style={{padding: "24px"}}>
                        <Button variant="contained"  className="mui-buttons" onClick={() => handleCreateCourse()}>
                          Create Course
                        </Button>
                      </div>
                    </div>
                  ): (null)}
                </Box>
              </div>
            )}
          </div>
        </div>
      </div>

    </div>
  )
}